import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import PostsSerializer from '@linc-technologies/linced-common/serializers/posts/base';

export default class Attendancenote extends PostsSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    mediaIds: { serialize: 'ids' },
  };

  payloadKeyFromModelName(modelName) {
    return super
      .payloadKeyFromModelName(modelName)
      .replace('attendancenote', 'post');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(key.replace('post', 'attendancenote'));
  }
}
